import developConfig from '../../config/dev.json';
import localConfig from '../../config/local.json';

export default function config() {
  switch(process.env.ENV) {
    case 'dev':
      return developConfig;
    default:
      return localConfig;
  }
}